import { apiClient } from "@/lib/api-client";
import type { Account } from "@/types/account";

export interface UpdateAccountPayload {
  name: string;
}

class AccountService {
  private path(accountId: string) {
    return `/accounts/${accountId}`;
  }

  async getAccount(accountId: string): Promise<Account> {
    return apiClient.get(this.path(accountId), { requiresAuth: true });
  }

  async updateAccount(accountId: string, data: UpdateAccountPayload): Promise<Account> {
    return apiClient.patch(this.path(accountId), data, { requiresAuth: true });
  }
}

export const accountService = new AccountService();
